import { render, staticRenderFns } from "./CancelCall.vue?vue&type=template&id=4087d96f&"
import script from "./CancelCall.vue?vue&type=script&lang=js&"
export * from "./CancelCall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports